export default __webpack_public_path__ + "static/media/institution-usyd.87a60f20.png";